import { Extension } from "@tiptap/core"
import type { Node } from "@tiptap/pm/model"
import { Plugin, PluginKey } from "@tiptap/pm/state"
import { Decoration, DecorationSet } from "@tiptap/pm/view"
import { DROP_CAP_MIN_LENGTH } from "../nodes/paragraph.js"

const dropCapKey = new PluginKey<DecorationSet>("dropCap")

function getDecorations(doc: Node): DecorationSet {
  const firstChild = doc.firstChild
  if (
    !firstChild ||
    firstChild.type.name !== "paragraph" ||
    firstChild.textContent.length <= DROP_CAP_MIN_LENGTH
  )
    return DecorationSet.empty

  return DecorationSet.create(doc, [
    Decoration.node(0, firstChild.nodeSize, { "data-drop-cap": "" }),
  ])
}

export const DropCapExtension = Extension.create({
  name: "dropCap",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: dropCapKey,
        state: {
          init(_, { doc }) {
            return getDecorations(doc)
          },
          apply(tr, old) {
            return tr.docChanged ? getDecorations(tr.doc) : old
          },
        },
        props: {
          decorations(state) {
            return dropCapKey.getState(state)
          },
        },
      }),
    ]
  },
})
